import { LawyerOrLawFirmStatus } from "../model/registrationEnums";

export const NOT_ELIGIBLE_LAW_FIRM_TEXT =
  "Aktier/anparter i et advokatselskab må kun ejes af andre advokatselskaber, jf. retsplejelovens § 124 c, stk. 1, nr. 2.";

export const NOT_ELIGIBLE_PARTNER_EXAM_TEXT =
  "Personer, der ikke er advokater, og som ønsker at eje aktier/anparter i et advokatselskab, skal for det første være ansat i selskabet og for det andet bestå den såkaldte partnerprøve, jf. bekendtgørelse om partnerprøven § 1. Vedkommende skal – efter at have erhvervet aktier/anparter – tilmelde sig den førstkommende partnerprøve hos Advokatsamfundet, jf. § 3. Læs mere herom på Advokatsamfundets hjemmeside.";

export const NON_LAWYER_COMBINED_OWNER_SHARE_HELPER =
  "Vær opmærksom på, at ikke-advokater til sammen maksimalt må eje under en tiendedel af aktierne/anparterne, svarende til 9,99 %, jf. retsplejelovens § 124 c, stk. 2.";

export const getNonLawyerOwnerShareHelper = (
  role: "deltager" | "interessent",
): string =>
  `Idet denne ${role} ikke er advokat, må vedkommende – alene, eller tilsammen med andre ikke-advokater – eje under en tiendedel af aktierne/anparterne i selskabet, svarende til 9,99 %, jf. retsplejelovens § 124 c, stk. 2, jf. stk. 1.`;

export const lawyerOrLawFirmSelectOptions = [
  { value: LawyerOrLawFirmStatus.Ja, label: "Ja" },
  {
    value: LawyerOrLawFirmStatus.IkkeAdvokatselskab,
    label: "Nej, selskabet er ikke et advokatselskab",
  },
  {
    value: LawyerOrLawFirmStatus.IkkeAdvokat,
    label: "Nej, personen er ikke advokat",
  },
];
